const initialState = {
  getFamilyHeadDetails: [],
  ncdPatientDetails: [],
  oraphanDetails: [],
  deathDetails: [],
  addDisabledMemberDetails: [],
  editDisabledMemberDetails: [],
  familyMembersDetails: [],
  familyHead: [],
  getState: 0,
  readState: 0,
  addState: 0,
  deathDetail: {},
  childFamilymemeber: {},
  familyDetails: {},
  pregnantFamilymemeber: {},
  createState: 0,
  delState: 0,
  upadtesate: 0,
  putState: 0,
  deleteState: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_FAMILY_HEAD_DETAILS_FULFILLED":
      return {
        ...state,
        getState: 2,
        getFamilyHeadDetails: action.payload.data,
      };

    case "CREATE_DEATH_DETAILS_FULFILLED":
      return {
        ...state,
        createState: 2,
        deathDetail: action.payload.data,
      };
    case "CREATE_DEATH_DETAILS_REJECTED":
      return { ...state, createState: 3 };
    case "CREATE_DEATH_DETAILS_PENDING":
      return { ...state, createState: 1 };
    case "GET_FAMILY_MEMBER_DETAILS_FULFILLED":
      return {
        ...state,
        getState: 2,
        familyMembersDetails: action.payload.data,
      };
    case "GET_FAMILY_MEMBER_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "GET_FAMILY_MEMBER_DETAILS_PENDING":
      return { ...state, getState: 1 };

    case "EDIT_DEATH_DETAILS_FULFILLED":
      return {
        ...state,
        upadtesate: 2,
        deathDetail: action.payload.data,
      };
    case "EDIT_DEATH_DETAILS_REJECTED":
      return { ...state, upadtesate: 3 };
    case "EDIT_DEATH_DETAILS_PENDING":
      return { ...state, upadtesate: 1 };

    case "DELETE_DEATH_DETAILS_PENDING":
      return { ...state, delState: 1 };
    case "DELETE_DEATH_DETAILS_FULFILLED":
      state.deathDetails = state.deathDetails.filter(
        (deathDetail) => deathDetail.id !== action.payload.data
      );
      return { ...state, delState: 2, deathDetail: state.deathDetail };
    case "DELETE_DEATH_DETAILS_REJECTED":
      return { ...state, delState: 3 };

    case "GET_FAMILY_HEAD_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "GET_FAMILY_HEAD_DETAILS_PENDING":
      return { ...state, getState: 1 };
    case "GET_NCD_PATIENT_DETAILS_FULFILLED":
      return {
        ...state,
        getState: 2,
        ncdPatientDetails: action.payload.data,
      };
    case "GET_NCD_PATIENT_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "GET_NCD_PATIENT_DETAILS_PENDING":
      return { ...state, getState: 1 };
    case "GET_ORPHAN_DETAILS_FULFILLED":
      return {
        ...state,
        getState: 2,
        oraphanDetails: action.payload.data,
      };
    case "GET_ORPHAN_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "GET_ORPHAN_DETAILS_PENDING":
      return { ...state, getState: 1 };
    case "GET_DEATH_DETAILS_FULFILLED":
      return {
        ...state,
        getState: 2,
        deathDetails: action.payload.data,
      };
    case "GET_DEATH_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "GET_DEATH_DETAILS_PENDING":
      return { ...state, getState: 1 };

    case "ADD_DISABLED_MEMBER_FULFILLED":
      return {
        ...state,
        getState: 2,
        addDisabledMemberDetails: action.payload.data,
      };
    case "ADD_DISABLED_MEMBER_REJECTED":
      return { ...state, getState: 3 };
    case "ADD_DISABLED_MEMBER_PENDING":
      return { ...state, getState: 1 };
    case "EDIT_DISABLED_MEMBER_FULFILLED":
      return {
        ...state,
        getState: 2,
        editDisabledMemberDetails: action.payload.data,
      };
    case "EDIT_DISABLED_MEMBER_REJECTED":
      return { ...state, getState: 3 };
    case "EDIT_DISABLED_MEMBER_PENDING":
      return { ...state, getState: 1 };
    case "DELETE_NCDS_DETAIL_FULFILLED":
      return {
        ...state,
        deleteState: 2,
      };
    case "DELETE_NCDS_DETAIL_REJECTED":
      return { ...state, deleteState: 3 };
    case "DELETE_NCDS_DETAIL_PENDING":
      return { ...state, deleteState: 1 };
    case "DELETE_CHILD_FULFILLED":
      return {
        ...state,
        deleteState: 2,
      };
    case "DELETE_CHILD_REJECTED":
      return { ...state, deleteState: 3 };
    case "DELETE_CHILD_PENDING":
      return { ...state, deleteState: 1 };
    case "UPDATE_NCDS_DETAIL_FULFILLED":
      return {
        ...state,
        putState: 2,
      };
    case "UPDATE_NCDS_DETAIL_REJECTED":
      return { ...state, putState: 3 };
    case "UPDATE_NCDS_DETAIL_PENDING":
      return { ...state, putState: 1 };
    case "ADD_NCDS_DETAIL_FULFILLED":
      return {
        ...state,
        addState: 2,
      };
    case "ADD_NCDS_DETAIL_REJECTED":
      return { ...state, addState: 3 };
    case "ADD_NCDS_DETAIL_PENDING":
      return { ...state, addState: 1 };
    case "DELETE_DISABLED_MEMBER_FULFILLED":
      return {
        ...state,
        getState: 2,
        editDisabledMemberDetails: action.payload.data,
      };
    case "DELETE_DISABLED_MEMBER_REJECTED":
      return { ...state, getState: 3 };
    case "DELETE_DISABLED_MEMBER_PENDING":
      return { ...state, getState: 1 };
    case "UPDATE_FAMILY_HEAD_FULFILLED":
      return {
        ...state,
        putState: 2,
      };
    case "UPDATE_FAMILY_HEAD_REJECTED":
      return { ...state, putState: 3 };
    case "UPDATE_FAMILY_HEAD_PENDING":
      return { ...state, putState: 1 };
    case "EDIT_FAMILY_FULFILLED":
      return {
        ...state,
        putState: 2,
      };
    case "EDIT_FAMILY_REJECTED":
      return { ...state, putState: 3 };
    case "EDIT_FAMILY_PENDING":
      return { ...state, putState: 1 };
    case "EDIT_CHILD_FULFILLED":
      return {
        ...state,
        putState: 2,
      };
    case "EDIT_CHILD_REJECTED":
      return { ...state, putState: 3 };
    case "EDIT_CHILD_PENDING":
      return { ...state, putState: 1 };

    case "DELETE_PREGNANT_LADY_FULFILLED":
      return {
        ...state,
        deleteState: 2,
      };
    case "DELETE_PREGNANT_LADY_REJECTED":
      return { ...state, deleteState: 3 };
    case "DELETE_PREGNANT_LADY_PENDING":
      return { ...state, deleteState: 1 };

    case "DELETE_FAMILY_MEMBER_FULFILLED":
      return {
        ...state,
        deleteState: 2,
      };
    case "DELETE_FAMILY_MEMBER_REJECTED":
      return { ...state, deleteState: 3 };
    case "DELETE_FAMILY_MEMBER_PENDING":
      return { ...state, deleteState: 1 };
    case "CREATE_FAMILY_PREGNANT_DETAILS_FULFILLED":
      return {
        ...state,
        createState: 2,
        pregnantFamilymemeber: action.payload.data,
      };
    case "CREATE_FAMILY_PREGNANT_DETAILS_REJECTED":
      return { ...state, createState: 3 };
    case "CREATE_FAMILY_PREGNANT_DETAILS_PENDING":
      return { ...state, createState: 1 };

    case "CREATE_FAMILY_CHILD_DETAILS_FULFILLED":
      return {
        ...state,
        createState: 2,
        childFamilymemeber: action.payload.data,
      };
    case "CREATE_FAMILY_CHILD_DETAILS_REJECTED":
      return { ...state, createState: 3 };
    case "CREATE_FAMILY_CHILD_DETAILS_PENDING":
      return { ...state, createState: 1 };

    case "CREATE_FAMILY_CHILD_DETAILS_FULFILLED":
      return {
        ...state,
        createState: 2,
        familyDetails: action.payload.data,
      };
    case "CREATE_FAMILY_CHILD_DETAILS_REJECTED":
      return { ...state, createState: 3 };
    case "CREATE_FAMILY_CHILD_DETAILS_PENDING":
      return { ...state, createState: 1 };

    case "UPDATE_FAMILY_HEAD_CHANGE_FULFILLED":
      return {
        ...state,
        createState: 2,
        familyHead: action.payload.data,
      };
    case "UPDATE_FAMILY_HEAD_CHANGE_REJECTED":
      return { ...state, createState: 3 };
    case "UPDATE_FAMILY_HEAD_CHANGE_PENDING":
      return { ...state, createState: 1 };

    default:
      return state;
  }
};

export default reducer;
